const fetchData = (URL, params, method = 'GET') => {
  const options = {
      method,
      headers: {
          'Content-Type': 'application/json'
      }
  };
  if (params && method !== 'GET') {
      options.body = JSON.stringify(params);
  }
  return fetch(URL, options).then(res => res.json())
}
const addGiftToCart = (id) => {
  let quantity = 1;
  let params = { items: [{ id, quantity }] };
  fetchData('/cart/add.js', params, 'POST')
      .then( item => {if(!item['statue'])document.dispatchEvent(new CustomEvent('cart:build'));})
}
const removeGiftFromCart = (id) => {
  let quantity = 0;
  let params = { id, quantity };
  fetchData('/cart/change.js', params, 'POST')
  .then( item => {if(!item['statue'])document.dispatchEvent(new CustomEvent('cart:build'));})
}
window.addEventListener('DOMContentLoaded', function () {
  const $checkboxGift = document.getElementById('hc-checkbox');
  $checkboxGift.addEventListener("change", function () {
      if (this.checked) {
          addGiftToCart(this.value);
          return;
      }
      removeGiftFromCart(this.value);
      return;
  })
});